import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";

class O {
  gatewayId!: number;
  // Null when the device itself was DRAFTED (never an official row) and got hard-deleted
  // along with its reverted draft, rather than reverted to its official state.
  deviceId?: number | null;
  updateTs?: string;
}

class I {
  gatewayId!: number;
  deviceId!: number;
}

export class RevertDevicePendingConfigCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.RevertDevicePendingConfig);
    this.i = new I();
    this.o = new O();
  }
}
